import { render, staticRenderFns } from "./StudentTrainList.vue?vue&type=template&id=c6b48db0&scoped=true"
import script from "./StudentTrainList.vue?vue&type=script&lang=js"
export * from "./StudentTrainList.vue?vue&type=script&lang=js"
import style0 from "./StudentTrainList.vue?vue&type=style&index=0&id=c6b48db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b48db0",
  null
  
)

export default component.exports